import React from "react";

export default () => {

    return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M19.8976 15.3975C19.7922 15.5028 19.6492 15.562 19.5001 15.562C19.3511 15.562 19.2081 15.5028 19.1026 15.3975L12.0001 8.29594L4.89763 15.3975C4.791 15.4969 4.64996 15.551 4.50424 15.5484C4.35851 15.5458 4.21947 15.4868 4.11641 15.3837C4.01335 15.2807 3.95432 15.1416 3.95175 14.9959C3.94918 14.8502 4.00327 14.7091 4.10263 14.6025L11.6026 7.1025C11.7081 6.99716 11.8511 6.938 12.0001 6.938C12.1492 6.938 12.2922 6.99716 12.3976 7.1025L19.8976 14.6025C20.003 14.708 20.0621 14.8509 20.0621 15C20.0621 15.1491 20.003 15.292 19.8976 15.3975Z" fill="#B94700"/>
    </svg>


}
